/* Roles de los usuarios */
export enum RolUsuario {
  ELEVA = 'eleva',
  ADMINISTRATIVO = 'administrativo',
  FARMACIA = 'farmacia',
  CLIENTE = 'cliente',
  ALIADO = 'aliado',
}

/* Objetos con permisos */
export enum Objeto {
  CLIENTE = 'cliente',
  VERIFICACION_IDENTIDAD = 'verificacionidentidad',
  ORDEN = 'orden',
  DOMICILIO = 'domicilio',
  RUTA = 'ruta',
  MENSAJE_SMS = 'mensajesms',
  PAQUETE = 'paquete',
  TRASLADO = 'traslado',
  PLANILLA_RECOGIDA = 'planillarecogida',
  PLANILLA_RETORNO = 'planillaretorno',
  PLANILLA_RODAMIENTO = 'planillarodamiento',
  REPORTE = 'reporte',
  TAREA = 'tarea',
  DIGITURNO = 'digiturno',
  ENCARGO = 'encargo',
  CUENTA_COBRO = 'cuentacobro',
  JORNADA = 'jornada',
  RECOGIDA = 'recogida',
  TIQUETE = 'tiquete',
  CAMPANA = 'campana',
  REGISTRO_TRAYECTO = 'registrotrayecto',
  CIERRE_CAJA = 'cierrecaja',
  CUENTA_PILOTO = 'cuentapiloto',
  MOVIMIENTO_CUENTA = 'movimientocuenta',
  CAJA_AUXILIAR = 'cajaauxiliar',
  MOVIMIENTO_CAJA = 'movimientocaja',
  RECEPCION_EFECTIVO = 'recepcionefectivo',
  PILOTO = 'piloto',
}

/* Permisos de los objetos */
export enum Permiso {
  VER = 'view',
  CREAR = 'add',
  EDITAR = 'change',
  ELIMINAR = 'delete',
  VER_MASIVO = 'view_massive',
  CREAR_MASIVO = 'add_massive',

  // Verificación de Identidad
  APROBAR = 'approve',

  // Mensajes SMS
  ENVIAR = 'send',
  ENVIAR_MASIVO = 'send_massive',

  // Órdenes
  VER_HISTORIAL_DETALLADO = 'view_historial_detallado',
  REVERTIR = 'revert',
  PREPARAR = 'prepare',
  RECOGER = 'pick_up',
  RETORNAR = 'return',

  // Domicilios
  CANCELAR = 'cancel',
  ENRUTAR = 'route',
  DESPACHAR = 'dispatch',
  ENTREGAR = 'checkout',
  PAGAR_RODAMIENTO = 'pay_rodamiento',
  LEGALIZAR = 'legalize',

  // Servicios
  RECOLECTAR = 'collect',
  INICIAR = 'start',
  COMPLETAR = 'complete',

  // Facturación
  CONFIRMAR = 'confirm',

  // CRM
  RESOLVER = 'resolve',

  // Campañas
  ACTIVAR = 'activate',
  PAUSAR = 'pause',

  // Caja
  // Recibir y anular son CREAR y CANCELAR sobre `RECEPCION_EFECTIVO`: los permisos nombran
  // el acto de mostrador, no el asiento contable que ese acto produce de paso. CANCELAR es
  // el mismo verbo que ya usa cuentas de cobro.
  AJUSTAR = 'adjust',
}

/* Permisos de los objetos */
export type Permisos = { [key in Objeto]?: Permiso[] };

/* Autorización necesaria para utilizar alguna funcionalidad */
export type Autorizacion = {
  permisos?: Permisos | Permisos[]; // Si es un array, se trata de un OR
  roles?: RolUsuario[];
  superusuario?: boolean; // Solo superusuarios
};

/* Estructura de Permisos en la API */
export interface PermisosDTO {
  permisos: Permisos;
  rol: RolUsuario;
  superusuario: boolean;
}
